import { render, staticRenderFns } from "./SopManager.vue?vue&type=template&id=3fd1b632&scoped=true&"
import script from "./SopManager.vue?vue&type=script&lang=ts&"
export * from "./SopManager.vue?vue&type=script&lang=ts&"
import style0 from "./SopManager.vue?vue&type=style&index=0&id=3fd1b632&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd1b632",
  null
  
)

export default component.exports